import * as React from "react";
import {Fragment} from "react";
import SmsNotification from "../../../model/notification/sms/SmsNotification";

interface ComponentProps {
	/**
	 * Notification to display in toaster.
	 */
	notification: SmsNotification
}

/**
 * Note notification toast body.
 */
const NotificationSmsBody: React.SFC<ComponentProps> = (props) => {
	return (
		<Fragment>
			<div className={"toast-header"}>{`SMS from ${props.notification.displayCreatorName()}`}</div>
			<div className={"toast-body"}>
				{props.notification.data.smsContent}
			</div>
		</Fragment>
	);
};

export default NotificationSmsBody;